const readMetricsValues = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  query: `
      readMetricsValues: readMetricsValues(condition: $condition, duration: $duration) {
        label
        values {
          values {value}
        }
        avg
        total
        perMin
      }`
};

const readMetricsValue = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  query: `
      readMetricsValue: readMetricsValue(condition: $condition, duration: $duration)`
};

const sortMetrics = {
  variable: ['$condition: TopNCondition!, $duration: Duration!'],
  query: `
      sortMetrics: sortMetrics(condition: $condition, duration: $duration) {
        name
        id
        value
        refId
      }`
};

const readLabeledMetricsValues = {
  variable: [
    '$condition: MetricsCondition!, $labels: [String!]!, $duration: Duration!'
  ],
  query: `
      readLabeledMetricsValues: readLabeledMetricsValues(
        condition: $condition,
        labels: $labels,
        duration: $duration) {
        label
        values {
          values {value}
        }
      }`
};

const readHeatMap = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  query: `
      readHeatMap: readHeatMap(condition: $condition, duration: $duration) {
        values {
          id
          values
        }
        buckets {
          min
          max
        }
      }`
};

const readSampledRecords = {
  variable: ['$condition: TopNCondition!, $duration: Duration!'],
  query: `
      readSampledRecords: readSampledRecords(condition: $condition, duration: $duration) {
        name
        value
        refId
      }`
};
const readMetricsTotalValue = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  query: `
    readMetricsTotalValue: readMetricsTotalValue(condition: $condition, duration: $duration)`
};

const readCustomMetricsValues = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  query: `
  readCustomMetricsValues: readCustomMetricsValues(condition: $condition, duration: $duration) {
      label
      values {
        values {value}
      }
      avg
      total
      perMin
    }`
};

const crashByFilter = {
  variable: ['$request:MobileMetricsBucketRequest!'],
  query: `
      response: crashByFilter(request:$request) {
          values {
              key
              values
          } 
      }
    `
};

const usage = {
  variable: ['$request:MobileMetricsBucketRequest!'],
  query: `
      response: usage(request:$request) {
          values {
              key
              values
          } 
      }
    `
};

const performanceByFilter = {
  variable: ['$request:MobileMetricsBucketRequest!'],
  query: `
      response: performanceByFilter(request:$request) {
          values {
              key
              values
          } 
      }
    `
};

const getGraphDataPulse = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  query: `
  getGraphDataPulse: getGraphData(condition: $condition, duration: $duration) {
      label
      values {
        values {value}
      }
      avg
      total
      perMin
    }`
};

const activeUsersByOs = {
  variable: ['$condition:MobileActiveUsers!'],
  query: `
      response: activeUsersByOs(request:$condition) {
        label,
        values {
          values {value}
        } 
      }
    `
};

const appEventsByOs = {
  variable: ['$condition:EventRequest!'],
  query: `
      response: appEventsByOs(request:$condition) {
        label,
        values {
          values {value}
        } 
      }
    `
};

const newRegisteredUsers = {
  variable: ['$condition:EventRequest!'],
  query: `
      response: newRegisteredUsers(request:$condition) {
        label,
        values {
          values {value}
        } 
      }
    `
};

const readAndAggregateMetricsFilteredAtServiceScope = {
  variable: ['$condition: MetricsCondition!,$duration: Duration!,$valueColumn: String,$properties: [KeyValuePair!]!'],
  query: `
  readAndAggregateMetricsFilteredAtServiceScope: readAndAggregateMetricsFilteredAtServiceScope(
    condition: $condition,
    duration: $duration, valueColumn: $valueColumn, properties: $properties) {
      label
      values {
        values {id value}
      }
      avg
      total
      perMin
      }`
};
export const readAIMetricValues = {
  variable: ['$condition: MetricsCondition!', '$duration: Duration!'],
  query:`
  readAIMetricsValues: readAIMetricsValues(condition: $condition, duration: $duration){
    success
        message
        data {queryId metric predictions{fv gt ut lt sev anomaly confidence time} anomalyCount }
  }
  `
}
const activeUsersByOsCompare = {
  variable: ['$condition:MobileActiveUsers!, $conditionCompared:MobileActiveUsers!'],
  query: `
      response: activeUsersByOs(request:$condition) {
        label,
        values {
          values {value}
        } 
      }
      responseCompared: activeUsersByOs(request:$conditionCompared) {
      label,
      values {
        values {value}
      } 
      }`
}

const appEventsByOsCompare = {
  variable: ['$condition:EventRequest!', '$conditionCompared:EventRequest!'],
  query: `
      response: appEventsByOs(request:$condition) {
        label,
        values {
          values {value}
        } 
      }
        responseCompared: appEventsByOs(request:$conditionCompared) {
        label,
        values {
          values {value}
        } 
      }`
};

const newRegisteredUsersCompare = {
  variable: ['$condition:EventRequest!', '$conditionCompared:EventRequest!'],
  query: `
      response: newRegisteredUsers(request:$condition) {
        label,
        values {
          values {value}
        } 
      }
        responseCompared: newRegisteredUsers(request:$conditionCompared) {
        label,
        values {
          values {value}
        } 
      }`
};

const usageCompare = {
  variable: ['$request:MobileMetricsBucketRequest!', '$requestCompared:MobileMetricsBucketRequest!'],
  query: `
      response: usage(request:$request) {
          values {
              key
              values
          } 
      }
      responseCompared: usage(request:$requestCompared) {
          values {
              key
              values
          } 
      }
    `
};

const readMetricsValuesCompare = {
  variable: ['$condition: MetricsCondition!, $durationCurrent: Duration!, $durationCompare: Duration!'],
  query: `
       readMetricsValues(condition: $condition, duration: $durationCurrent) {
        label
        values {
          values {value}
        }
        avg
        total
        perMin
      }
        compared: readMetricsValues(condition: $condition, duration: $durationCompare) {
        label
        values {
          values {value}
        }
        avg
        total
        perMin
      }`
};

const crashByFilterCompare = {
  variable: ['$request:MobileMetricsBucketRequest!', '$requestCompared:MobileMetricsBucketRequest!'],
  query: `
      response: crashByFilter(request:$request) {
          values {
              key
              values
          } 
      }
      responseCompared: crashByFilter(request:$requestCompared) {
      values {
          key
          values
      } 
  } `
};

 const readCustomMetricsValuesCompare = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!,$durationCompare: Duration!'],
  query: `
  readCustomMetricsValues(condition: $condition, duration: $duration) {
      label
      values {
        values {value}
      }
      avg
      total
      perMin
    }
    compared: readCustomMetricsValues(condition: $condition, duration: $durationCompare) {
      label
      values {
        values {value}
      }
      avg
      total
      perMin
    }`
};

const readLabeledMetricsValuesCompare = {
  variable: ['$condition: MetricsCondition!, $labels: [String!]!, $durationCurrent: Duration! ,$durationCompare: Duration!'],
  query: `
      readLabeledMetricsValues(condition: $condition,labels: $labels,duration: $durationCurrent) {
        label
        values {
          values {value}
        }
      }
        compared: readLabeledMetricsValues(condition: $condition,labels: $labels,duration: $durationCompare) {
        label
        values {
          values {value}
        }
      }`
};


export default {
  readSampledRecords,
  readHeatMap,
  readLabeledMetricsValues,
  sortMetrics,
  readMetricsValue,
  readMetricsValues,
  readMetricsTotalValue,
  readCustomMetricsValues,
  crashByFilter,
  performanceByFilter,
  getGraphDataPulse,
  activeUsersByOs,
  appEventsByOs,
  newRegisteredUsers,
  usage,
  readAndAggregateMetricsFilteredAtServiceScope,
  readAIMetricValues,
  activeUsersByOsCompare,
  appEventsByOsCompare,
  newRegisteredUsersCompare,
  usageCompare,
  readMetricsValuesCompare,
  crashByFilterCompare,
  readCustomMetricsValuesCompare,
  readLabeledMetricsValuesCompare,
};
